import { render } from "./ModuleEdit.vue?vue&type=template&id=54b6ca08&scoped=true"
import script from "./ModuleEdit.vue?vue&type=script&lang=js"
export * from "./ModuleEdit.vue?vue&type=script&lang=js"

import "./ModuleEdit.vue?vue&type=style&index=0&id=54b6ca08&scoped=true&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b6ca08"]])

export default __exports__